/* eslint-disable @typescript-eslint/promise-function-async -- Preserve shared promise identity for cached reads. */
import type { EventProfile } from '../../event-profile.js';
import type { OfflineCartReads, OfflineCartSources, ReadResult } from './types.js';

type LoadOnceArgs<T> = Readonly<{
  cache: Map<string, Promise<ReadResult<T>>>;
  key: string;
  load: () => Promise<ReadResult<T>>;
}>;

export type CreateValidationReadsArgs = Readonly<{
  sources: OfflineCartSources;
}>;

function loadOnce<T>(args: LoadOnceArgs<T>): Promise<ReadResult<T>> {
  const existing = args.cache.get(args.key);
  if(existing !== undefined) return existing;

  // Store before invoking IO, including adapters that throw synchronously.
  const pending = Promise.resolve()
      .then(args.load)
      .catch((cause: unknown): ReadResult<T> => ({ kind: 'unavailable', cause }));
  args.cache.set(args.key, pending);
  return pending;
}

export function createValidationReads(args: CreateValidationReadsArgs): OfflineCartReads {
  const events = new Map<string, Promise<ReadResult<EventProfile>>>();
  return {
    getEventProfile: (key) => loadOnce({
      cache: events,
      key: JSON.stringify([key.businessRef.encode(), key.eventId]),
      load: () => args.sources.getEventProfile(key),
    }),
  };
}
